import {
    IAppUserModel,
    IImportUserModel,
    IRecentClientListingModel,
    IUserModel,
    RecentClientListingModel,
    UserModel
} from "@common/models";
import { IGetUserRecordModel } from "@common/models/IGetUserRecordModel";
import { IRecentUserClientRequestModel } from "@common/models/requests/RecentUserClientRequestModel";
import { http } from "@common/utils";
import { trackPromise } from "react-promise-tracker";

export class UserService {

    private static baseUrl: string = '/api/user';

    public static tags = {
        getUser: "getUser",
        getUserIdByUsername: "getUserIdByUsername",
        updateUser: "updateUser",
        addRecentClient: "addRecentClient",
        getRecentClients: "getRecentClients",
        importUser: "importUser",
        getUserRecordByObjectIdentifier: "getUserRecordByObjectIdentifier"
    }

    static getUser = (userId: number): Promise<UserModel> =>
        trackPromise(new Promise<UserModel>((resolve, reject) => {
            http(`${this.baseUrl}/${userId}`)
                .get<IUserModel>()
                .then(json => resolve(new UserModel(json)))
                .catch(reject)
        }), this.tags.getUser);

    static getUserIdByUsername = (username: string): Promise<number> =>
        trackPromise(new Promise<number>((resolve, reject) => {
            http(`${this.baseUrl}/username/${username}`)
                .get<number>()
                .then(userId => resolve(userId))
                .catch(reject)
        }), this.tags.getUserIdByUsername);

    static updateUser = (userId: number, user: Partial<UserModel>): Promise<void> =>
        trackPromise(new Promise<void>((resolve, reject) => {
            http(`${this.baseUrl}/${userId}`).get<IUserModel>().then(data => {
                const currentUser = new UserModel(data);
                http(`${this.baseUrl}`)
                    .post<void>(new UserModel({ ...currentUser, ...user }))
                    .then(resolve)
            }).catch(reject)
        }), this.tags.updateUser);

    static addRecentClient = (request: IRecentUserClientRequestModel): Promise<void> =>
        trackPromise(new Promise<void>((resolve, reject) => {
            http(`${this.baseUrl}/addrecentclient`)
                .post<void>(request)
                .then(resolve)
                .catch(reject)
        }), this.tags.addRecentClient);

    static getRecentClients = (userId: number): Promise<RecentClientListingModel[]> =>
        trackPromise(new Promise<RecentClientListingModel[]>((resolve, reject) => {
            http(`${this.baseUrl}/getrecentclients/${userId}`)
                .get<IRecentClientListingModel[]>()
                .then((json) => {
                    const recentClients = json.map((client) => new RecentClientListingModel(client));
                    resolve(recentClients)
                })
                .catch(reject)
        }), this.tags.getRecentClients);

    static importUser = (request: IImportUserModel): Promise<IAppUserModel> =>
        trackPromise(new Promise<IAppUserModel>((resolve, reject) => {
            http(`${this.baseUrl}/import`)
                .post<IAppUserModel>(request)
                .then(data => {
                    resolve(data);
                })
                .catch(data => {
                    reject(data)
                })
        }), this.tags.importUser);

    static getUserRecordByObjectIdentifier = (request: IGetUserRecordModel): Promise<IAppUserModel> =>
        trackPromise(new Promise<IAppUserModel>((resolve, reject) => {
            http(`${this.baseUrl}/record`)
                .post<IAppUserModel>(request)
                .then(data => {
                    resolve(data);
                })
                .catch(data => {
                    reject(data)
                })
        }), this.tags.getUserRecordByObjectIdentifier);
}
